<template>
	<div class="float-right mt-0">
		<button class="btn_ic ic22-enlarge ace_sec_txt" v-on:click="fullScreenWindow" aria-label="click to enter fullscreen"></button>
		<button class="btn_ic ic22-shrink ace_sec_txt" v-on:click="exitFullScreen" aria-label="click to exit fullscreen"></button>
	</div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'fullScreenMethod',
    props: ['action'],

    methods: {
      ...mapActions([
        'loadLogDashboardActivity'
      ]),

      fullScreenWindow () {
        if (this.action) {
          let courseId = this.$parent.uuid
          let resourceId = this.$parent.entityUuid
          let entityUuid = courseId + '&resourceUuid=' + resourceId
          this.loadLogDashboardActivity({action: this.action, page: 'courseLearn', link: '', entityUuid: entityUuid})
        }
        $('.can_full_screen').addClass('full_screen')
      },

      exitFullScreen () {
        $('.can_full_screen').removeClass('full_screen')
      }
    }

  }
</script>


<style scoped>

	*:fullscreen
	*:-ms-fullscreen,
	*:-webkit-full-screen,
	*:-moz-full-screen {
	   overflow: auto !important;
	}

</style>



// WEBPACK FOOTER //
// src/app/misc/components/fullScreenMethod.vue